var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap",
      staticStyle: { top: "-85px", width: "800px" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v(" close ")]
      ),
      _c("form", [
        _c("div", { staticClass: "popup_cont" }, [
          _c("h1", { staticClass: "page_title" }, [
            _vm._v(_vm._s(_vm.$t("msg.COUP100.061"))),
          ]),
          _c("h1", { staticStyle: { "font-size": "120%" } }, [
            _vm._v(_vm._s(_vm.$t("msg.COUP100.063"))),
          ]),
          _c(
            "div",
            {
              staticClass: "content_box",
              staticStyle: { "margin-top": "3px" },
            },
            [
              _c("h1", { staticStyle: { "font-size": "100%" } }, [
                _vm._v(_vm._s(_vm.$t("msg.COUP100.064"))),
              ]),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "3px", "font-size": "100%" },
                },
                [_vm._v(_vm._s(_vm.$t("msg.COUP100.065")))]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                },
                [_c("br"), _vm._v("· " + _vm._s(_vm.$t("msg.COUP100.066")))]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "3px", "font-size": "100%" },
                },
                [_vm._v("     " + _vm._s(_vm.$t("msg.COUP100.067"))), _c("br")]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "5px" },
                },
                [_vm._v("· " + _vm._s(_vm.$t("msg.COUP100.068")))]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "3px", "font-size": "100%" },
                },
                [_vm._v("     " + _vm._s(_vm.$t("msg.COUP100.069"))), _c("br")]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "5px" },
                },
                [_vm._v("· " + _vm._s(_vm.$t("msg.COUP100.070")))]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "3px", "font-size": "100%" },
                },
                [_vm._v("     " + _vm._s(_vm.$t("msg.COUP100.071"))), _c("br")]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "5px" },
                },
                [_vm._v("· " + _vm._s(_vm.$t("msg.COUP100.072")))]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "3px", "font-size": "100%" },
                },
                [_vm._v("     " + _vm._s(_vm.$t("msg.COUP100.073"))), _c("br")]
              ),
            ]
          ),
          _c("h1", { staticStyle: { "font-size": "120%" } }, [
            _c("br"),
            _vm._v(_vm._s(_vm.$t("msg.COUP100.083"))),
          ]),
          _c(
            "div",
            {
              staticClass: "content_box",
              staticStyle: { "margin-top": "3px" },
            },
            [
              _c("h1", { staticStyle: { "font-size": "100%" } }, [
                _vm._v(_vm._s(_vm.$t("msg.COUP100.074"))),
              ]),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang == "JP",
                      expression: "currentServiceLang == 'JP'",
                    },
                  ],
                  staticStyle: { "font-size": "100%" },
                },
                [_vm._v(_vm._s(_vm.$t("msg.COUP100.084")))]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang == "JP",
                      expression: "currentServiceLang == 'JP'",
                    },
                  ],
                  staticStyle: { "font-size": "100%" },
                },
                [_vm._v(_vm._s(_vm.$t("msg.COUP100.085")))]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                },
                [_c("br"), _vm._v("· " + _vm._s(_vm.$t("msg.COUP100.075")))]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "3px", "font-size": "100%" },
                },
                [_vm._v("     " + _vm._s(_vm.$t("msg.COUP100.076"))), _c("br")]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "5px" },
                },
                [_vm._v("· " + _vm._s(_vm.$t("msg.COUP100.077")))]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "3px", "font-size": "100%" },
                },
                [_vm._v("     " + _vm._s(_vm.$t("msg.COUP100.078"))), _c("br")]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "5px" },
                },
                [_vm._v("· " + _vm._s(_vm.$t("msg.COUP100.079")))]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "3px", "font-size": "100%" },
                },
                [_vm._v("     " + _vm._s(_vm.$t("msg.COUP100.067"))), _c("br")]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "5px" },
                },
                [_vm._v("· " + _vm._s(_vm.$t("msg.COUP100.070")))]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "3px", "font-size": "100%" },
                },
                [_vm._v("     " + _vm._s(_vm.$t("msg.COUP100.071"))), _c("br")]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "5px" },
                },
                [_vm._v("· " + _vm._s(_vm.$t("msg.COUP100.072")))]
              ),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang !== "JP",
                      expression: "currentServiceLang !== 'JP'",
                    },
                  ],
                  staticStyle: { "margin-top": "3px", "font-size": "100%" },
                },
                [_vm._v("     " + _vm._s(_vm.$t("msg.COUP100.080"))), _c("br")]
              ),
            ]
          ),
          _c("h1", { staticStyle: { "font-size": "120%" } }, [
            _c("br"),
            _vm._v(_vm._s(_vm.$t("msg.COUP100.081"))),
          ]),
          _c(
            "div",
            {
              staticClass: "content_box",
              staticStyle: { "margin-top": "3px" },
            },
            [
              _c("h1", { staticStyle: { "font-size": "100%" } }, [
                _vm._v(_vm._s(_vm.$t("msg.COUP100.082"))),
              ]),
              _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentServiceLang == "JP",
                      expression: "currentServiceLang == 'JP'",
                    },
                  ],
                  staticStyle: { "font-size": "100%" },
                },
                [_vm._v(_vm._s(_vm.$t("msg.COUP100.086")))]
              ),
            ]
          ),
          _c(
            "h1",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentServiceLang == "JP",
                  expression: "currentServiceLang == 'JP'",
                },
              ],
              staticStyle: { "font-size": "120%" },
            },
            [_c("br"), _vm._v(_vm._s(_vm.$t("msg.COUP100.087")))]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentServiceLang == "JP",
                  expression: "currentServiceLang == 'JP'",
                },
              ],
              staticClass: "content_box",
              staticStyle: { "margin-top": "3px" },
            },
            [
              _c("h1", { staticStyle: { "font-size": "100%" } }, [
                _vm._v(_vm._s(_vm.$t("msg.COUP100.088"))),
              ]),
              _c("h1", { staticStyle: { "font-size": "100%" } }, [
                _vm._v(_vm._s(_vm.$t("msg.COUP100.089"))),
              ]),
            ]
          ),
          _c("div", { staticStyle: { "text-align": "center" } }, [
            _c(
              "a",
              {
                staticClass: "button blue lq",
                staticStyle: { "font-size": "larger", "margin-top": "10px" },
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.closeBtn()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("msg.COUP100.060")))]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }